import { debug } from '@/config';

import {
  analyticsEvent,
  analyticsPageview,
  getConsent,
  updateAnalyticsConsent,
} from '@/libs/ga4';
import { CookiePreferences } from '@tikkie/blokkie';

export function useAnalytics() {
  const trackPageView = () => {
    const page = window.location.pathname;
    if (debug) {
      console.log('analytics: trackPageView', { page });
    }
    analyticsPageview(page);
  };

  const trackEvent = (
    eventName: string,
    parameters?: Record<string, unknown>
  ) => {
    const category = 'recycling';
    if (debug) {
      console.log('analytics: trackEvent', { eventName, category, parameters });
    }
    analyticsEvent(eventName, category, parameters);
  };

  const updateConsent = (cookiePreferences: CookiePreferences) => {
    const consent = getConsent(cookiePreferences);
    updateAnalyticsConsent(consent);
  };

  return {
    trackEvent,
    trackPageView,
    updateConsent,
  };
}
